import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToTarget } from "../lib/scroll";

const linkCls = "font-sans font-medium text-sm transition-colors duration-300";

export const Nav = ({ links, cta }) => (
  <header className="fixed top-0 inset-x-0 z-50 bg-bone/80 backdrop-blur-md border-b border-ink/10">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
      <Link to="/" className="focus:outline-none" aria-label="Construction Alliance home">
        <Logo />
      </Link>
      <nav className="hidden md:flex items-center gap-8">
        {links.map((l) => {
          const testId = `nav-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
          const cls = `${linkCls} ${l.accent ? "text-teal hover:text-ink" : "text-ink/60 hover:text-ink"}`;
          return l.to ? (
            <Link key={l.label} to={l.to} className={cls} data-testid={testId}>{l.label}</Link>
          ) : (
            <button key={l.label} onClick={() => scrollToTarget(l.target)} className={cls} data-testid={testId}>{l.label}</button>
          );
        })}
      </nav>
      <button
        onClick={() => scrollToTarget(cta.target)}
        data-testid={cta.testId}
        className="bg-ink text-bone font-display font-medium text-sm px-4 sm:px-6 py-2.5 whitespace-nowrap transition-colors duration-300 hover:bg-teal"
      >
        <span className="sm:hidden">{cta.short}</span>
        <span className="hidden sm:inline">{cta.label}</span>
      </button>
    </div>
  </header>
);
